module.exports = __webpack_public_path__ + "img/loading.2602ad09.svg";